module.exports = __webpack_public_path__ + "48861219b36cdf33724abec17f8651eb.svg";